import { render, staticRenderFns } from "./radioBoxImgSet.vue?vue&type=template&id=16aa5567&scoped=true&"
import script from "./radioBoxImgSet.vue?vue&type=script&lang=js&"
export * from "./radioBoxImgSet.vue?vue&type=script&lang=js&"
import style0 from "./radioBoxImgSet.vue?vue&type=style&index=0&id=16aa5567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa5567",
  null
  
)

export default component.exports